const AppBanner = () => import("./AppBanner.vue");
const AppBannerPage = () => import("./views/AppBannerPage.vue");

const moduleRoute = {
  path: "/banner",
  component: AppBanner,
  props: true,
  children: [
    {
      path: "",
      component: AppBannerPage,
      name: "AppBannerPage",
      props: true,
      meta: {
        title: "Banner Configuration ",
        auth: true,
      },
    },
  ],
};

export default (router) => {
  router.addRoute(moduleRoute);
};
